import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { tanimlarApi } from '../services/api';
import DataTable, { DtColumn } from '../components/DataTable';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const YIL = new Date().getFullYear();
const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

const emptyForm = {
  isletme_id: '', yil: YIL, ay: 12, mulkiyet_kod: 'V.2.2.1',
  hizmet_otosu: 0, kamyon: 0, kamyonet: 0, minibus: 0, midibus: 0,
  hasta_nakil: 0, cekici_treyler: 0, su_arazoz_tankeri: 0,
  akaryakit_tankeri: 0, itfaiye: 0, seyyar_atolye: 0, aciklama: ''
};

export default function TasitVarligi() {
  const [kayitlar,         setKayitlar]         = useState<any[]>([]);
  const [isletmeler,       setIsletmeler]       = useState<any[]>([]);
  const [mulkiyetTanimlar, setMulkiyetTanimlar] = useState<any[]>([]);
  const [modalAcik,        setModalAcik]        = useState(false);
  const [form,       setForm]       = useState<any>({ ...emptyForm });
  const [filtre,     setFiltre]     = useState((() => {
    const sp = new URLSearchParams(window.location.search);
    return {
      isletme_id: sp.get('isletme') || '',
      yil: Number(sp.get('yil') || YIL),
      ay: sp.get('ay') || ''
    };
  })());
  const [hata,       setHata]       = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const userStr = localStorage.getItem('user');
  const user    = userStr ? JSON.parse(userStr) : null;
  const isGM    = user?.rol && ['super_admin','gm_yonetici','gm_personel'].includes(user.rol);
  const isAdmin = user?.rol && ['super_admin','gm_yonetici'].includes(user.rol);

  const [kiralikGoster, setKiralikGoster] = useState(false);

  const mulkAd = (kod: string) => mulkiyetTanimlar.find(t => t.kod === kod)?.ad || kod;
  const mulkBadge = (kod: string) => kod === 'V.2.2.1' ? 'aktif' : 'pasif';

  useEffect(() => {
    if (!isGM && user?.isletme_id) setFiltre(f => ({ ...f, isletme_id: user.isletme_id }));
    axios.get(`${API}/api/tanimlar2/liste`, { headers: headers(), params: { ust: 'V.2.2', sadece_yaprak: true } }).then(r => setMulkiyetTanimlar(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(kiralikGoster).then(r => setIsletmeler(r.data));
  }, [kiralikGoster]);

  useEffect(() => { yukle(); }, [filtre]);

  const yukle = () => {
    const p: any = { yil: filtre.yil };
    if (filtre.isletme_id) p.isletme_id = filtre.isletme_id;
    if (filtre.ay) p.ay = Number(filtre.ay);
    axios.get(`${API}/api/varlik/tasit`, { headers: headers(), params: p }).then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
  };

  const mevcuduYukle = async (isletme_id: any, yil: number) => {
    if (!isletme_id) return;
    try {
      const r = await axios.get(`${API}/api/varlik/tasit`, { headers: headers(), params: { isletme_id, yil } });
      const mevcut = r.data?.[0];
      if (mevcut) setForm({ ...mevcut });
    } catch {}
  };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      if (form.id) {
        await axios.put(`${API}/api/varlik/tasit/${form.id}`, { ...form, isletme_id: Number(form.isletme_id) }, { headers: headers() });
      } else {
        await axios.post(`${API}/api/varlik/tasit`, { ...form, isletme_id: Number(form.isletme_id) }, { headers: headers() });
      }
      yukle(); setModalAcik(false); setForm({ ...emptyForm });
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Silmek istiyor musunuz?')) return;
    try { await axios.delete(`${API}/api/varlik/tasit/${id}`, { headers: headers() }); yukle(); } catch {}
  };

  const silSecili = async (rows: any[]) => {
    for (const k of rows) await axios.delete(`${API}/api/varlik/tasit/${k.id}`, { headers: headers() });
    yukle();
  };

  const n = (v: any) => Number(v || 0).toLocaleString('tr-TR');

  const tasitColumns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (k: any) => <><strong>{k.isletme_kod}</strong><br /><small>{k.isletme_ad}</small></>, sortValue: (k: any) => k.isletme_kod || '', filterValue: (k: any) => k.isletme_ad || '', exportValue: (k: any) => `${k.isletme_kod} ${k.isletme_ad}` },
    { key: 'yil', label: 'Yıl', sortable: true, filterable: true, sortValue: (k: any) => Number(k.yil), filterValue: (k: any) => String(k.yil) },
    { key: 'ay', label: 'Ay', sortable: true, filterable: true, render: (k: any) => AYLAR[k.ay] || k.ay, filterValue: (k: any) => AYLAR[k.ay] || String(k.ay), sortValue: (k: any) => Number(k.ay) },
    { key: 'mulkiyet_kod', label: 'Mülkiyet', filterable: true, render: (k: any) => <span className={`badge badge-${mulkBadge(k.mulkiyet_kod)}`}>{mulkAd(k.mulkiyet_kod)}</span>, filterValue: (k: any) => mulkAd(k.mulkiyet_kod) },
    { key: 'hizmet_otosu', label: 'Hiz.Oto', sortable: true, render: (k: any) => n(k.hizmet_otosu), sortValue: (k: any) => Number(k.hizmet_otosu || 0) },
    { key: 'kamyon', label: 'Kamyon', sortable: true, render: (k: any) => n(k.kamyon), sortValue: (k: any) => Number(k.kamyon || 0) },
    { key: 'kamyonet', label: 'Kamyonet', sortable: true, render: (k: any) => n(k.kamyonet), sortValue: (k: any) => Number(k.kamyonet || 0) },
    { key: 'minibus', label: 'Minibüs', sortable: true, render: (k: any) => n(k.minibus), sortValue: (k: any) => Number(k.minibus || 0) },
    { key: 'midibus', label: 'Midibüs', sortable: true, render: (k: any) => n(k.midibus), sortValue: (k: any) => Number(k.midibus || 0) },
    { key: 'hasta_nakil', label: 'H.Nakil', sortable: true, render: (k: any) => n(k.hasta_nakil), sortValue: (k: any) => Number(k.hasta_nakil || 0) },
    { key: 'cekici_treyler', label: 'Çek.Trey.', sortable: true, render: (k: any) => n(k.cekici_treyler), sortValue: (k: any) => Number(k.cekici_treyler || 0) },
    { key: 'su_arazoz_tankeri', label: 'Su/Arazöz', sortable: true, render: (k: any) => n(k.su_arazoz_tankeri), sortValue: (k: any) => Number(k.su_arazoz_tankeri || 0) },
    { key: 'akaryakit_tankeri', label: 'Akaryakıt', sortable: true, render: (k: any) => n(k.akaryakit_tankeri), sortValue: (k: any) => Number(k.akaryakit_tankeri || 0) },
    { key: 'itfaiye', label: 'İtfaiye', sortable: true, render: (k: any) => n(k.itfaiye), sortValue: (k: any) => Number(k.itfaiye || 0) },
    { key: 'seyyar_atolye', label: 'Seyyar At.', sortable: true, render: (k: any) => n(k.seyyar_atolye), sortValue: (k: any) => Number(k.seyyar_atolye || 0) },
    { key: 'toplam', label: 'Toplam', sortable: true, render: (k: any) => <strong>{n(k.toplam)}</strong>, sortValue: (k: any) => Number(k.toplam || 0) },
    { key: 'islem', label: 'İşlem', noExport: true, render: (k: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => { setForm({ ...k }); setHata(''); setModalAcik(true); }}>Düzenle</button>}
        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>
      </div>
    )},
  ];

  const ozet = React.useMemo(() => {
    const s = (f: string) => kayitlar.reduce((acc, k) => acc + (k[f] || 0), 0);
    return {
      hizmet_otosu:     s('hizmet_otosu'),
      kamyon:           s('kamyon'),
      itfaiye:          s('itfaiye'),
      kamyonet:         s('kamyonet'),
      minibus:          s('minibus'),
      midibus:          s('midibus'),
    };
  }, [kayitlar]);

  const inp = (field: string) => ({
    className: "form-control", type: "number" as const, value: form[field],
    onChange: (e: any) => setForm({ ...form, [field]: Number(e.target.value) })
  });

  return (
    <div>
      <div className="page-header">
        <h1>🚗 Taşıt Varlığı</h1>
        <p>İşletme bazında yıllık taşıt varlığı verileri</p>
      </div>

      {kayitlar.length > 0 && (
        <div className="stats-grid" style={{ marginBottom: 16 }}>
          <div className="stat-card"><div className="stat-icon">🚗</div><div><div className="stat-value">{n(ozet.hizmet_otosu)}</div><div className="stat-label">Hizmet Otosu</div></div></div>
          <div className="stat-card"><div className="stat-icon">🚛</div><div><div className="stat-value">{n(ozet.kamyon)}</div><div className="stat-label">Kamyon</div></div></div>
          <div className="stat-card"><div className="stat-icon">🚒</div><div><div className="stat-value">{n(ozet.itfaiye)}</div><div className="stat-label">İtfaiye</div></div></div>
          <div className="stat-card"><div className="stat-icon">🚐</div><div><div className="stat-value">{n(ozet.kamyonet)}</div><div className="stat-label">Kamyonet</div></div></div>
          <div className="stat-card"><div className="stat-icon">🚌</div><div><div className="stat-value">{n(ozet.minibus)}</div><div className="stat-label">Minibüs</div></div></div>
          <div className="stat-card"><div className="stat-icon">🚍</div><div><div className="stat-value">{n(ozet.midibus)}</div><div className="stat-label">Midibüs</div></div></div>
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8 }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 120 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value="">Tüm Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
            </select>
            {isGM && (
              <>
                <select className="search-input" style={{ width: 210 }} value={filtre.isletme_id}
                  onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                  <option value="">Tüm İşletmeler</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
                <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, cursor:'pointer', whiteSpace:'nowrap' }}>
                  <input type="checkbox" checked={kiralikGoster} onChange={e => setKiralikGoster(e.target.checked)} />
                  Kiralıkları Göster
                </label>
              </>
            )}
          </div>
          <button className="btn btn-success" onClick={() => { setForm({ ...emptyForm, isletme_id: isGM ? '' : user?.isletme_id }); setHata(''); setModalAcik(true); }}>+ Yeni Kayıt</button>
        </div>
        <DataTable columns={tasitColumns} data={kayitlar} rowKey={(k: any) => k.id} onDeleteSelected={silSecili} exportFilename="tasit-varligi" />
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 580, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>🚗 Taşıt Varlığı Kayıt Girişi</h3><button className="modal-close" onClick={() => setModalAcik(false)}>×</button></div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              <div className="form-row">
                {isGM && (
                  <div className="form-group"><label>İşletme *</label>
                    <select className="form-control" value={form.isletme_id} onChange={e => {
                      const yeniId = e.target.value;
                      setForm({ ...emptyForm, isletme_id: yeniId, yil: form.yil });
                      mevcuduYukle(yeniId, form.yil);
                    }}>
                      <option value="">Seçiniz</option>
                      {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group"><label>Yıl *</label><input className="form-control" type="number" value={form.yil} onChange={e => {
                  const yeniYil = Number(e.target.value);
                  setForm({ ...emptyForm, isletme_id: form.isletme_id, yil: yeniYil, ay: form.ay });
                  mevcuduYukle(form.isletme_id, yeniYil);
                }} /></div>
                <div className="form-group"><label>Ay *</label>
                  <select className="form-control" value={form.ay} onChange={e => setForm({ ...form, ay: Number(e.target.value) })}>
                    {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
                  </select>
                </div>
              </div>
              <div className="form-group"><label>Mülkiyet Durumu *</label>
                <select className="form-control" value={form.mulkiyet_kod || 'V.2.2.1'} onChange={e => setForm({ ...form, mulkiyet_kod: e.target.value })}>
                  {mulkiyetTanimlar.map(t => <option key={t.kod} value={t.kod}>{t.ad}</option>)}
                </select>
              </div>
              <p style={{ fontWeight: 'bold', fontSize: 13, color: '#1a5276', margin: '8px 0 6px' }}>🚗 Taşıt Varlığı</p>
              <div className="form-row">
                <div className="form-group"><label>Hizmet Otosü</label><input {...inp('hizmet_otosu')} /></div>
                <div className="form-group"><label>Kamyon</label><input {...inp('kamyon')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Kamyonet</label><input {...inp('kamyonet')} /></div>
                <div className="form-group"><label>Minibüs</label><input {...inp('minibus')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Midibüs</label><input {...inp('midibus')} /></div>
                <div className="form-group"><label>Hasta Nakil Aracı</label><input {...inp('hasta_nakil')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Çekici-Treyler</label><input {...inp('cekici_treyler')} /></div>
                <div className="form-group"><label>Su Tankeri/Arazöz</label><input {...inp('su_arazoz_tankeri')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Akaryakıt Tankeri</label><input {...inp('akaryakit_tankeri')} /></div>
                <div className="form-group"><label>İtfaiye</label><input {...inp('itfaiye')} /></div>
              </div>
              <div className="form-group"><label>Seyyar Atölye</label><input {...inp('seyyar_atolye')} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
